import { render, staticRenderFns } from "./WebCamDialog.vue?vue&type=template&id=20d55f6c&"
import script from "./WebCamDialog.vue?vue&type=script&lang=js&"
export * from "./WebCamDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports